import { Injectable }
from '@angular/core';

import {
  HttpClient
}
from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  private api =
    'https://lazzaro-api1.onrender.com/api/Products';

  private categoriesApi =
    'https://lazzaro-api1.onrender.com/api/categories';

  private cloudinaryUrl =
    'https://api.cloudinary.com/v1_1/dle6ao4m7/image/upload';

  constructor(
    private http: HttpClient
  ) { }

  createProduct(product: any)
  {
    return this.http.post(
      this.api,
      product,
      {
        headers: {
          'Content-Type':
            'application/json'
        }
      }
    );
  }

  uploadImage(file: File)
  {
    const formData =
      new FormData();

    formData.append(
      'file',
      file
    );

    formData.append(
      'upload_preset',
      'lazzaro_unsigned'
    );

    return this.http.post(
      this.cloudinaryUrl,
      formData
    );
  }

  getCategories()
  {
    return this.http.get(
      this.categoriesApi
    );
  }
}